import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { GradientPage } from '../../components/common';
import { ChangePasswordForm } from '../../components/profile/ChangePasswordForm';

class ChangePassword extends Component {
  styles = getStyles();

  render() {
    return (
      <GradientPage>
        <View style={this.styles.form}>
          <ChangePasswordForm />
        </View>
      </GradientPage>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    form: {
      marginHorizontal: 17,
    },
  });

export default ChangePassword;
